export default __webpack_public_path__ + "static/media/hotei_main.7244b752.webp";